import React, { Component } from 'react';
import { Modal, Table, Input, InputNumber, DatePicker, Button, message, Spin, Tooltip } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const TextArea = Input.TextArea;

class EditableCell extends Component {
    handleDateChange = (value, dateString) => {
        this.props.onChange(dateString);
    }

    handleInputNumberChange = (value) => {
        this.props.onChange(value);
    }

    handleInputNumberBlur = (e) => {
        const { minScore, maxScore } = this.props;
        const value = e.target.value || 0;
        if (value < minScore || value > maxScore) {
            message.warning('输入的分值不在范围内');
            this.props.onChange('');
        }
    }

    handleInputChange = (e) => {
        this.props.onChange(e.target.value);
    }

    getWebType = () => {
        const { type, value, minScore, maxScore } = this.props;
        const placeholder = `${minScore}~${maxScore}`;
        let dom = null;
        if (type == 'INPUTNUMBER') {
            dom = (
                <InputNumber
                    placeholder={`请输入得分(${placeholder})`}
                    precision={0}
                    value={value}
                    style={{ width: '100%' }}
                    onChange={this.handleInputNumberChange}
                    onBlur={this.handleInputNumberBlur}
                />
            );
        } else if (type == 'DATE') {
            const newValue = value ? moment(value) : null;
            dom = (
                <DatePicker
                    value={newValue}
                    placeholder="请选择"
                    onChange={this.handleDateChange}
                />
            );
        } else if (type == 'INPUT') {
            dom = (
                <Input
                    value={value}
                    placeholder="请输入"
                    style={{ width: '100%' }}
                    onChange={this.handleInputChange}
                />
            );
        }
        return dom;
    }

    render() {
        return (
            <div>{this.getWebType()}</div>
        )
    }
}

class UpdateScore extends Component {
    state = {
        loading: false,
        visible: false,
        params: {},
    }

    show = (record) => {
        this.setState({
            data: [],
            visible: true,
            loading: true,
            params: { ...record },
        }, () => {
            this.getData();
        });
    }

    getData = () => {
        const {
            params: {
                encourageTeamMembers,
                positiveEnergyPromotion,
                teamUnity,
                total,
            }
        } = this.state;
        const { config } = this.props;
        const data = [];
        data.push({
            name: '鼓励团队成员',
            scoreValue: encourageTeamMembers,
            key: 'encourageTeamMembers',
            maxScore: config.maxEncourageTeamMembers,
            minScore: config.minEncourageTeamMembers,
        }, {
            name: '正能量宣传',
            scoreValue: positiveEnergyPromotion,
            key: 'positiveEnergyPromotion',
            maxScore: config.maxPositiveEnergyPromotion,
            minScore: config.minPositiveEnergyPromotion,
        }, {
            name: '团队凝聚力',
            scoreValue: teamUnity,
            key: 'teamUnity',
            maxScore: config.maxTeamUnity,
            minScore: config.minTeamUnity,
        }, {
            name: '合计',
            scoreValue: total,
        });
        this.setState({
            data,
            loading: false,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    getColumns = () => [{
        title: '考核内容',
        dataIndex: 'name',
        width: 240,
        render: (text) => {
            if (text == '合计') {
                return <strong>合计</strong>;
            } else {
                return text;
            }
        }
    }, {
        title: '得分',
        dataIndex: 'scoreValue',
        render: (text, record, index) => {
            if (record.name != '合计') {
                return this.renderColumns(text, record, 'INPUTNUMBER', false, 'scoreValue', index);
            } else {
                const { data } = this.state;
                let value = 0;
                if (index == 3) {
                    value = this.filterData(data[0].scoreValue) + this.filterData(data[1].scoreValue) + this.filterData(data[2].scoreValue);
                } else if (index == 7) {
                    value = this.filterData(data[4].scoreValue) + this.filterData(data[5].scoreValue) + this.filterData(data[6].scoreValue);
                }
                return <strong>{value}</strong>;
            }
        },
    }]

    filterData = (value) => {
        if (value) {
            const result = parseInt(value, 10)
            return Number.isNaN(result) ? 0 : result;
        } else {
            return 0;
        }
    }

    renderColumns = (text, record, type, disabled, column, index) => {
        return (
            <EditableCell
                disabled={disabled}
                value={text}
                type={type}
                minScore={record.minScore}
                maxScore={record.maxScore}
                onChange={value => this.handleChange(value, index, column)}
            />
        );
    }

    handleChange = (value, index, column) => {
        const { data, params } = this.state;
        data[index][column] = value;
        params[data[index]['key']] = value;
        this.setState({
            data,
            params,
        });
    }

    handleTextAreaChange = (e) => {
        const { params } = this.state;
        params.comments = e.target.value;
        this.setState({ params });
    }

    submit = () => {
        const {
            params,
            params: {
                comments,
                encourageTeamMembers,
                positiveEnergyPromotion,
                teamUnity,
            }
        } = this.state;
        if (!encourageTeamMembers && encourageTeamMembers !== 0) {
            message.warning('请填写鼓励团队成员得分');
            return;
        } else if (!positiveEnergyPromotion && positiveEnergyPromotion !== 0) {
            message.warning('请填写正能量宣传得分');
            return;
        } else if (!teamUnity && teamUnity !== 0) {
            message.warning('请填写团队凝聚力得分');
            return;
        }
        if (!comments || comments.trim() == '') {
            message.warning('请填写主管总结性评语');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.editPmScoreGrade,
            data: {
                ...params,
                appraiseUser: null,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    visible: false,
                    loading: false,
                }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options);
    }

    render() {
        const {
            visible,
            params: {
                employeeCode,
                comments,
                inspectionTime,
                userCompellation,
            },
            loading,
            data,
        } = this.state;
        return (
            <Modal
                title="评分"
                visible={visible}
                onCancel={this.hide}
                wrapClassName="vertical-center-modal crcQuarterScore"
                width="500px"
                maskClosable={false}
                footer={
                    <span>
                        <Button type="ghost" size="large" onClick={this.hide}>关闭</Button>
                        <Button type="primary" size="large" onClick={this.submit} loading={loading}>提交</Button>
                    </span>
                }
            >
                <Spin spinning={loading}>
                    <div style={{ position: 'relative' }}>
                        <div style={{ lineHeight: '48px' }}>
                            <span>考核时间：{inspectionTime ? inspectionTime.slice(0, 7) : ''}</span>
                            <span style={{ marginLeft: 32 }}>PM: {userCompellation}({employeeCode})</span>
                        </div>
                        <Table
                            pagination={false}
                            rowKey={row => row.key}
                            columns={this.getColumns()}
                            dataSource={data}
                        />
                        <div style={{ marginTop: 20, marginBottom: 30 }}>
                            <div>
                                <span style={{ color: 'red' }}>*</span>主管总结性评语：
                                <TextArea
                                    rows={4}
                                    value={comments}
                                    placeholder="请输入"
                                    onChange={this.handleTextAreaChange}
                                    style={{ width: 350, verticalAlign: 'text-top' }}
                                />
                            </div>
                        </div>
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateScore;


// WEBPACK FOOTER //
// ./src/components/user/pmInfo/UpdateScore.js